import i18n from '@dms/i18n';

import {CLASSIFIEDS_DEFAULT_ORDER_ID} from './CLASSIFIEDS_DEFAULT_ORDER_ID';
import {USER_LIST_DEFAULT_ORDER_ID} from './USER_LIST_DEFAULT_ORDER_ID';

export const CLASSIFIEDS_SORT_BY = [
  {
    name: i18n.t('entity.vehicle.labels.sortByNewestAd'),
    orderBy: ['-first_occurrence'],
    id: CLASSIFIEDS_DEFAULT_ORDER_ID,
  },
  {
    name: i18n.t('entity.vehicle.labels.sortByOldestAd'),
    orderBy: ['first_occurrence'],
    id: 'OLDEST_AD',
  },
  {
    name: i18n.t('entity.vehicle.labels.sortByLowestMileage'),
    orderBy: ['mileage_range'],
    id: 'LOWEST_MILEAGE',
  },
  {
    name: i18n.t('entity.vehicle.labels.sortByNewestCar'),
    orderBy: ['-year'],
    id: 'NEWEST_CAR',
  },
  {
    name: i18n.t('entity.vehicle.labels.sortByHighestPrice'),
    orderBy: ['-price'],
    id: 'HIGHEST_PRICE',
  },
  {
    name: i18n.t('entity.vehicle.labels.sortByLowestPrice'),
    orderBy: ['price'],
    id: 'LOWEST_PRICE',
  },
  {
    name: i18n.t('entity.vehicle.labels.sortByFeatureRank'),
    orderBy: ['-feature_score'],
    id: 'FEATURE_RANK',
  },
];

const CLASSIFIEDS_USER_LIST_SORT_BY = [
  {
    id: USER_LIST_DEFAULT_ORDER_ID,
    name: i18n.t('entity.vehicle.labels.sortByLastAdded'),
    orderBy: [] as string[],
  },
  ...CLASSIFIEDS_SORT_BY,
];

/**
 * Sort options for user list pages (Favourites, To Buy, Hidden).
 * Prepends "Last added" as the default before the standard classifieds sort options.
 */
export const CLASSIFIEDS_USER_LIST_SORT_OPTIONS = CLASSIFIEDS_USER_LIST_SORT_BY.map((item) => ({
  value: item.id,
  label: item.name,
  orderBy: item.orderBy,
}));

/**
 * O(1) lookup for user list pages: sort id -> orderBy param string.
 */
export const CLASSIFIEDS_USER_LIST_ORDER_BY_MAP = new Map(
  CLASSIFIEDS_USER_LIST_SORT_BY.map((item) => [item.id, item.orderBy])
);

const CLASSIFIEDS_ALL_OFFER_SORT_BY = [
  ...CLASSIFIEDS_SORT_BY,
  {
    id: 'MAX_MARGIN',
    name: i18n.t('entity.vehicle.labels.sortByMaxMargin'),
    orderBy: ['-max_margin'],
  },
];

/**
 * Sort options for the All Offers page.
 * Appends "Max margin" after the standard classifieds sort options.
 */
export const CLASSIFIEDS_ALL_OFFER_SORT_OPTIONS = CLASSIFIEDS_ALL_OFFER_SORT_BY.map((item) => ({
  value: item.id,
  label: item.name,
  orderBy: item.orderBy,
}));

/**
 * O(1) lookup for the All Offers page: sort id -> orderBy param string.
 */
export const CLASSIFIEDS_ALL_OFFER_ORDER_BY_MAP = new Map(
  CLASSIFIEDS_ALL_OFFER_SORT_BY.map((item) => [item.id, item.orderBy])
);
